<p-card [header]="isEditMode ? ('Update ' + unitLabel) : ('Create ' + unitLabel)">
    <form [formGroup]="createWarehouseForm">

        <div class="field col-12 flex justify-content-between align-items-center">

            <div class="field text-left">
                <div class="flex justify-content-start">
                    <p-button [label]="isEditMode ? 'Update' : 'Save'" icon="pi pi-save" size="small"
                        (click)="saveWarehouse(createWarehouseForm.value, isEditMode)"></p-button>
                    <p-button label="Cancel" icon="pi pi-times" size="small" (click)="Cancel()" severity="danger"
                        class="p-button-sm ml-2"></p-button>
                </div>
            </div>

            <div style="display: flex; align-items: center; gap: 10px;">
                <label class="block label-required font-bold">Required Field</label>

                <p-button *ngIf="isEditMode" label="View" (click)="menu.toggle($event)" [raised]="true" severity="info"
                    size="small">
                </p-button>

                <p-tieredMenu #menu [model]="items" [popup]="true"></p-tieredMenu>
            </div>

        </div>

        <div class="card flex justify-content-end mr-2">
            <p-checkbox formControlName="isActive" [binary]="true" inputId="binary" value="IsActive"
                label="Active"></p-checkbox>
        </div>
        <div class="grid">
            <div class="col">
                <div class="field text-left">
                    <label for="website" class="label-required display">{{unitLabel}} Code</label>
                    <input pInputText placeholder="e.g 101" formControlName="warehouseCode"
                        (keydown)="onKeydown($event)" [readOnly]="isEditMode"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.warehouseCode.errors }"
                        class="w-full p-inputtext-sm" />
                    <small *ngIf="submitted && formControls.warehouseCode.errors" id="warehouseCode-error"
                        class="text-red-500">Required
                        field.</small>
                </div>
                <div class="field text-left">
                    <label for="website" class="label-required display">{{unitLabel}} Serial </label>
                    <input pInputText placeholder="e.g PUN/011/25" class="w-full p-inputtext-sm"
                        formControlName="unitSerial" (keydown)="onKeydown($event)"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.unitSerial.errors }"
                        class="w-full p-inputtext-sm" />
                </div>
            </div>
            <div class="col">
                <div class="field text-left">
                    <label for="website" class="label-required display">{{unitLabel}} Name</label>
                    <input pInputText placeholder="e.g ABC" class="w-full p-inputtext-sm"
                        formControlName="warehouseName" (keydown)="onKeydown($event)"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.warehouseName.errors }"
                        class="w-full p-inputtext-sm" />
                    <small *ngIf="submitted && formControls.warehouseName.errors" id="warehouseName-error"
                        class="text-red-500">Required
                        field.</small>
                </div>

                <div class="field text-left">
                    <label for="website" class="label-required display">Starting Number</label>
                    <input pInputText class="w-full p-inputtext-sm" formControlName="startingNumber"
                        (keydown)="onKeydown($event)" [readonly]="isEditMode"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.startingNumber.errors }"
                        class="w-full p-inputtext-sm" />
                </div>

            </div>

            <!-- <div class="col">
                <div class="field text-left">
                    <label for="website">Description</label>
                    <textarea pInputText placeholder="e.g Production department working" class="w-full p-inputtext-sm" formControlName="unitsofMeasureDescription"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.unitsofMeasureDescription.errors }" rows="6"></textarea>
                    <small *ngIf="submitted && formControls.unitsofMeasureDescription.errors" id="unitsofMeasureDescription-error" class="text-red-500">Required
                        field.</small>
                </div>
            </div> -->
        </div>

        <p-tabView>
            <p-tabPanel header="General Information">
                <!-- <div class="formgrid grid"> -->
                <div class="grid ">
                    <div class="col">
                        <div class="field text-left" formGroupName="address">
                            <label for="address" class="label-required display">Address</label>
                            <input pInputText placeholder="Street Address" class="w-full p-inputtext-sm"
                                formControlName="addressLine1" (keydown)="onKeydown($event)"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.addressLine1.errors}" />
                            <small *ngIf="submitted && formControls.address.controls.addressLine1.errors"
                                id="name-error" class="text-red-500">Required field.</small>
                            <input pInputText placeholder="Street Address 2" class="w-full p-inputtext-sm mt-1"
                                formControlName="addressLine2" (keydown)="onKeydown($event)" />

                            <div class="flex mt-1">
                                <div>
                                    <input pInputText placeholder="City" class="w-full p-inputtext-sm"
                                        formControlName="city"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.city.errors }"
                                        (keydown)="onKeydown($event)" />
                                    <small *ngIf="submitted && formControls.address.controls.city.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div>

                                <div class=" ml-1">
                                    <!-- <input pInputText placeholder="State" class="w-full p-inputtext-sm" formControlName="state" [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }"/> -->
                                    <p-autoComplete [dropdown]="true" (onBlur)="checkState()" [forceSelection]="true"
                                        [readonly]="true" (onSelect)="setState($event)" placeholder="State"
                                        formControlName="state" [suggestions]="filterStates"
                                        (completeMethod)="filterState($event)" field="stateName"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }"
                                        (keydown.enter)="focusNextInput($event)"></p-autoComplete>
                                    <small *ngIf="submitted && formControls.address.controls.state.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div>

                                <div class=" ml-1">
                                    <input pInputText placeholder="Zip" class="w-full p-inputtext-sm"
                                        formControlName="zip"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.zip.errors }"
                                        (keydown)="onKeydown($event)" />
                                    <small *ngIf="submitted && formControls.address.controls.zip.errors" id="name-error"
                                        class="text-red-500">Required field.</small>
                                    <small
                                        *ngIf="formControls.address.controls.zip.value && formControls.address.controls.zip.value.length !== 6"
                                        id="zip-invalid-error" class="text-red-500">Zip code must be exactly 6
                                        digits.</small>

                                </div>

                            </div>
                            <input pInputText placeholder="Country" class="w-full p-inputtext-sm mt-1"
                                formControlName="country"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.country.errors}"
                                (keydown)="onKeydown($event)" />
                            <small *ngIf="submitted && formControls.address.controls.country.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                        <!-- <div class="field text-left">
                            <label for="tags" class="label-required display">GSTIN</label>
                            <input pInputText placeholder="GSTIN" (keydown)="onKeydown($event)"
                                class="w-full p-inputtext-sm" formControlName="gstin"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.gstin.errors}" />

                            <small *ngIf="submitted 
                                    && !formControls.gstin.errors?.['required'] 
                                    && formControls.gstin.errors?.['invalidGstin']" class="text-red-500">
                                Invalid GSTIN format.
                            </small>

                            <small *ngIf="submitted && createWarehouseForm.errors?.['stateMismatch']"
                                class="text-red-500">
                                GSTIN state does not match selected state.
                            </small>

                        </div> -->
                        <div class="field text-left">

                            <!-- Label -->
                            <label class="display" [ngClass]="{'label-required': isEinvoiceEnabled}">
                                GSTIN
                            </label>

                            <!-- Input -->
                            <input pInputText placeholder="GSTIN" formControlName="gstin" (keydown)="onKeydown($event)"
                                class="w-full p-inputtext-sm" [ngClass]="{
           'ng-invalid ng-dirty':
           isEinvoiceEnabled && submitted && formControls.gstin.errors
         }" />

                            <!-- Invalid Format -->
                            <small *ngIf="isEinvoiceEnabled
        && submitted
        && formControls.gstin.errors?.['invalidGstin']" class="text-red-500">
                                Invalid GSTIN format.
                            </small>

                            <!-- State mismatch -->
                            <small *ngIf="isEinvoiceEnabled
        && submitted
        && createWarehouseForm.errors?.['stateMismatch']" class="text-red-500">
                                GSTIN state does not match selected state.
                            </small>

                        </div>



                        <div class="field text-left ">
                            <label for="phone" class="label-required display">Contact Person Name</label>
                            <input pInputText placeholder="Contact Name" class="w-full p-inputtext-sm"
                                formControlName="contactName"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.contactName.errors }"
                                (keydown)="onKeydown($event)" />
                        </div>
                    </div>
                    <div class="col ">
                        <!-- <div class="field text-left ">
                        <label for="phone">Contact Person Name</label>
                        <input pInputText placeholder="Contact Name" class="w-full p-inputtext-sm" formControlName="contactName" [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.contactName.errors }" (keydown)="onKeydown($event)" />
                    </div> -->
                        <div class="field text-left">
                            <label for="mobile" class="label-required display">Mobile</label>
                            <input pInputText placeholder="Mobile" class="w-full p-inputtext-sm"
                                formControlName="mobile"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.mobile.errors }"
                                (keydown)="onKeydown($event)" />
                        </div>
                        <div class="field text-left">
                            <label for="phone">Phone</label>
                            <input pInputText placeholder="Phone" class="w-full p-inputtext-sm" formControlName="phone"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.phone.errors }"
                                (keydown)="onKeydown($event)" />
                        </div>
                        <div class="field text-left">
                            <label for="email" class="label-required display">Email</label>
                            <input pInputText placeholder="Email" class="w-full p-inputtext-sm" formControlName="email"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.email.errors }"
                                (keydown)="onKeydown($event)" />
                        </div>
                        <div class="field text-left">
                            <label for="panNo">Pan Number</label>
                            <input pInputText placeholder="panNo" (keydown)="onKeydown($event)"
                                class="w-full p-inputtext-sm" formControlName="panNo" />
                        </div>

                    </div>
                    <!-- </div>  -->
                </div>
            </p-tabPanel>
        </p-tabView>
    </form>
    <p-toast></p-toast>